<script setup lang="ts">
import bookJson from "@/assets/lottie/book-loader.json"
import {DotLottieVue} from "@lottiefiles/dotlottie-vue";
</script>

<template>
  <div class="absolute w-full h-full z-9999 left-0 top-0 bg-white">
    <!-- Loading Screen Overlay -->
    <Transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-500"
        enter-from-class="opacity-0"
        leave-to-class="opacity-0">
      <!--          v-if="appLoaderIsLoading"-->
      <div
          class="fixed inset-0 z-50 flex items-center justify-center bg-background">
        <div class="w-full max-w-md px-6 space-y-2 flex flex-col items-center">
          <!-- Logo/Brand -->
          <div class="text-center space-y-4">
            <!-- Replace with your actual logo -->
            <div class="inline-flex items-center justify-center w-20 h-20 bg-primary/10 rounded-2xl mb-4">
              <UIcon name="i-lucide-graduation-cap" class="size-10 text-primary"/>
            </div>

            <h1 class="text-3xl font-bold text-highlighted">
              منصة التعليم الإلكتروني
            </h1>
            <p class="text-muted">
              استعد للتعلم والنمو
            </p>
          </div>
          <DotLottieVue style="height: 150px; width: 150px" autoplay loop
                        :data="JSON.stringify(bookJson)"/>
          <div class="text-center space-y-2 pt-4">
            <UIcon name="i-lucide-lightbulb" class="size-5 text-primary mx-auto"/>
            <p class="text-xs text-muted italic">
              💡 نصيحة: خصص 30 دقيقة يومياً للتعلم لتحقيق أفضل النتائج
            </p>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
